
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({providedIn: 'root'})

export class VariablesSalir {
  public variableSalir: BehaviorSubject<boolean>;
  public salir$: Observable<boolean>;

  public variableEstaCupon: BehaviorSubject<boolean>;
  public estaCupon$: Observable<boolean>;



  constructor() {
    this.variableSalir = new BehaviorSubject<boolean>(false);
    this.salir$ = this.variableSalir.asObservable();
    this.variableEstaCupon = new BehaviorSubject<boolean>(false);
    this.estaCupon$ = this.variableSalir.asObservable();
  }


  public get valorSalir(): boolean {
    return this.variableSalir.value;
  }

  cambiarValorSalir(valor: boolean) {
    this.variableSalir.next(valor);
  }


  public get valorestaCupon(): boolean {
    return this.variableEstaCupon.value;
  }

  cambiarValorEstaCupon(valor: boolean) {
    this.variableEstaCupon.next(valor);
  }

}
